import type { InternalAxiosRequestConfig, AxiosResponse } from "axios";
import axios from "axios";
import { API_BASE_URL } from "./consts";
import { getCookie } from "@/lib/getCookie";
import { setCookie } from "@/lib/setCookie";

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request Interceptor
instance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const token = getCookie("accessToken"); // Fetch token dynamically
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
instance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    if (error.response?.status === 401) {
      setCookie("accessToken", "");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default instance;
